










































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditGwequipment from "./edit-gwequipment.vue";
import CreateGwequipment from "./create-gwequipment.vue";
class PageGwequipmentRequest extends PageRequest {
  //FilterText: string;

  Mac:string;
  locationName:string;
  frequency:string;
  remark:string;

}
class PageCompanyRequest{
  cId:Number;
}

@Component({
  components: {EditGwequipment,CreateGwequipment },
})
export default class Gwequipments extends AbpBase {
  pagerequest: PageGwequipmentRequest = new PageGwequipmentRequest();
  publicpagerequest: PageGwequipmentRequest = new PageGwequipmentRequest();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  userName: string;
    cId:Number;
   
  get list() {
    return this.$store.state.gwequipment.list;
  }
  get loading() {
    return this.$store.state.gwequipment.loading;
  }
  pageChange(page: number) {
    this.$store.commit("gwequipment/setCurrentPage", page);
    this.getPage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("gwequipment/setPageSize", pagesize);
    this.getPage();
  }
  async getAll() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    await this.$store.dispatch({
      type: "gwequipment/getAll",
      data: this.pagerequest,
    });
  }
  getsearch(){
    this.$store.state.thequipment.currentPage=1;
    this.getPage();
  }
  async getPage() {
    this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    await this.$store.dispatch({
      type: "gwequipment/getPaged",
      data: this.pagerequest,
    });
  }

  edit() {
    this.editModalShow = true;
  }
  create() {
    this.createModalShow = true;
  }
  get pageSize() {
    return this.$store.state.gwequipment.pageSize;
  }
  get totalCount() {
    return this.$store.state.gwequipment.totalCount;
  }
  get currentPage() {
    return this.$store.state.gwequipment.currentPage;
  }
  getuserName() {
    //console.log(this.$store.state.session.user);
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
  get company() {
    return this.$store.state.company.list;
  }
  companylist() {
    return this.$store.state.company.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.list;
  }
  get floor() {
    return this.$store.state.floor.list;
  }
  warehouselist() {
    return this.$store.state.warehouse.list;
  }
  floorlist() {
    return this.$store.state.floor.list;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  factorylist(){
    return this.$store.state.factory.list;
  }
  selCompany(value:Number){
    this.pagecompanyrequest.cId = value;
    this.getfactory();
    this.getwarehouse();
      this.getfloor();
       this.getAll();
  }
  columns = [
        {
      title: "所属公司",
      key: "cId",
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(cId==entry.id){
            cId=entry.cName;
            break;
          }
        }
        if(cId==0){
          cId="";
        }
        return h("span", cId);
      },
    },
    {
      title: "库区",
      key: "ftId",
      render: (h, params) => {
        let Id = params.row.ftId;
        let flist = this.factorylist();
        for (let entry of flist) {
          //console.log(entry.id); // 1, "string", false
          if(Id==entry.id){
            Id=entry.fName;
            break;
          }
        }
        return h("span", Id);
      },
    },
    {
      title: "库房",
      key: "wId",
       render: (h, params) => {
        let wId = params.row.wId;
        let clist = this.warehouselist();
        //console.log(clist); 
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(wId==entry.id){
            wId=entry.wName;
            break;
          }
        }
        return h("span", wId);
      },
    },
    {
      title: "楼层",
      key: "fId",
      render: (h, params) => {
        let fId = params.row.fId;
        let clist = this.floorlist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(fId==entry.id){
            fId=entry.fName;
            break;
          }
        }
        return h("span", fId);
      },
    },
    {
      title: "SN号",
      key: "mac",
    },
    {
      title: "物联网卡号",
      key: "iotCard",
    },
    {
      title: "管辖范围",
      key: "scope",
    },
    {
      title: "位置",
      key: "locationName",
    },
    {
      title: "网关频段",
      key: "frequency",
    },
    {
      title: "操作",
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  //console.log(params.row);
                  this.$store.commit("gwequipment/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: "提示",
                    content: "确认删除该条数据？",
                    okText: "删除",
                    cancelText: "取消",
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "gwequipment/delete",
                        data: params.row,
                      });
                      await this.getPage();
                    },
                  });
                },
              },
            },
            "删除"
          ),
        ]);
      },
    },
  ];
  async getcompany() {
    //filters
    await this.$store.dispatch({
      type: "company/getAll"
    });
   
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getAll",
      data: this.pagecompanyrequest,
    });
  }
   async getthreshold(){
      //阈值方案
    //filters
    await this.$store.dispatch({
      type: "threshold/getAll",
      data: this.publicpagerequest,
    });
  }
   async getfactory(){
      //库区
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      data: this.pagecompanyrequest,
    });
  }
 
 created() {
    this.getuserName();
     this.getfactory();
      this.getwarehouse();
      this.getfloor();
    if (this.userName !== "admin") {
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    } else {
      this.getcompany();
    }

    this.getPage();
    
  }
}
